import React from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { AnnouncementBanner } from "@/components/AnnouncementBanner";

export const Layout = ({ children }) => (
  <div className="App text-white">
    <div className="sticky top-0 z-50">
      <AnnouncementBanner />
      <Navbar />
    </div>
    <main>{children}</main>
    <Footer />
  </div>
);
